module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the preparation of this book I would like to thank all those who have offered advice and support, and all those who have helped me with my research. I am indebted to Mr John Franklin for his guidance, advice and provision of some research materials. Furthermore, I must also thank my excellent research team, M. Yves Martin, Ian J. Smith, John Lubomski and Sally Fairweather, for their generous assistance with, and photographing of, archival material at the Archives Nationales and Service Historique de la Défence Armée du Tére, in Paris. Without their help, the research for the book could not have been completed in two years, or the data analysed to the same degree.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Alasdair White has been of great assistance in our numerous discussions of the action at Hougoumont, for which I am grateful.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I need to also thank Martin Lancaster for our discussions on the empire, the emperor and Waterloo, as well for our more than twenty years of friendship and adding critical comment and much-needed analysis of the events of 18 June 1815.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lieutenant Colonel Timmermans must be thanked for providing some illustrations. I heartily encourage visitors to his excellent website: "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://napoleon-monuments.eu/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("http://Napoléon-monuments.eu/")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rachel Cresswell BA (Hons) PGCE and Sally Fairweather must be thanked for proofreading this text.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4bbbc5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Acknowledgements.vue
// module id = 69
// module chunks = 0